module.exports = __webpack_public_path__ + "assets/b0e2db3b634d1bc3928e127458d993d8.eot";